import api from "../../config/client.axios.api";

export const forgotPasswordApiRequest = async (email: string) => {
  const response = await api.post(`/auth/forgot`, { email });
  return response.data;
};
